import { render, staticRenderFns } from "./FormTime.vue?vue&type=template&id=21e0195c"
import script from "./FormTime.vue?vue&type=script&lang=ts"
export * from "./FormTime.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports